module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rt-header"
  }, [_vm._t("default"), _vm._v(" "), (_vm.hasBottom) ? _c('div', {
    staticClass: "header-bottom"
  }, [_vm._t("bottom")], 2) : _vm._e(), _vm._v(" "), _c('el-collapse-transition', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.state.showMore),
      expression: "state.showMore"
    }]
  }, [_vm._t("extra")], 2)])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-06dfb70a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-xpc/src/components/layout/rtHeader.vue
// module id = 1456
// module chunks = 124